/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonBasicDataViewModel } from "../types/PersonBasicDataViewModel.ts";
import { eGenderSchema } from "./eGenderSchema.ts";
import { eMartialStatusSchema } from "./eMartialStatusSchema.ts";

export const personBasicDataViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("Identificador único da pessoa.")),
  code: z
    .string()
    .describe("Código de identificação da pessoa no sistema. Opcional.")
    .nullish(),
  firstName: z.string().describe("Primeiro nome da pessoa.").nullish(),
  lastName: z.string().describe("Sobrenome da pessoa.").nullish(),
  alias: z
    .string()
    .describe("Apelido ou nome alternativo da pessoa. Opcional.")
    .nullish(),
  email: z
    .string()
    .describe("Endereço de e-mail pessoal da pessoa. Opcional.")
    .nullish(),
  corporateEmail: z
    .string()
    .describe("Endereço de e-mail corporativo da pessoa. Opcional.")
    .nullish(),
  birthDate: z
    .string()
    .datetime()
    .describe("Data de nascimento da pessoa. Opcional.")
    .nullish(),
  gender: z.optional(
    z
      .lazy(() => eGenderSchema)
      .describe("1 = Male | 2 = Female | 3 = IDontWantToAnswer | "),
  ),
  martialStatus: z.optional(
    z
      .lazy(() => eMartialStatusSchema)
      .describe("0 = Uninformed | 1 = Married | 2 = Unmarried | "),
  ),
  spouseName: z
    .string()
    .describe("Nome do cônjuge da pessoa. Opcional.")
    .nullish(),
  fathersName: z
    .string()
    .describe("Nome do pai da pessoa. Opcional.")
    .nullish(),
  mothersName: z
    .string()
    .describe("Nome da mãe da pessoa. Opcional.")
    .nullish(),
  nationalityId: z
    .number()
    .int()
    .describe("ID da nacionalidade associada à pessoa. Opcional.")
    .nullish(),
  birthCityId: z
    .number()
    .int()
    .describe("ID da cidade de nascimento associada à pessoa. Opcional.")
    .nullish(),
  birthCityName: z
    .string()
    .describe("Nome da cidade de nascimento da pessoa. Opcional.")
    .nullish(),
  birthStateId: z
    .number()
    .int()
    .describe("ID do estado de nascimento associado à pessoa. Opcional.")
    .nullish(),
  birthStateName: z
    .string()
    .describe("Nome do estado de nascimento da pessoa. Opcional.")
    .nullish(),
  birthCountryId: z
    .number()
    .int()
    .describe("ID do país de nascimento associado à pessoa. Opcional.")
    .nullish(),
  birthCountryName: z
    .string()
    .describe("Nome do país de nascimento da pessoa. Opcional.")
    .nullish(),
  photo: z
    .string()
    .describe("URL ou caminho da foto de perfil da pessoa. Opcional.")
    .nullish(),
}) as unknown as ToZod<PersonBasicDataViewModel>;
